import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { AppSharedModule } from '../../app-shared.module';
import { AnalyticTypeInfoDialogComponent } from './components/analytic-type-info-dialog/analytic-type-info-dialog.component';
import { CallbackUrlDialogComponent } from './components/callback-url-dialog/callback-url-dialog.component';
import { ConfigurationAnalyticItemsSummaryComponent } from './components/configuration-analytic-items-summary/configuration-analytic-items-summary.component';
import { ConfigurationOverviewComponent } from './components/configuration-overview/configuration-overview.component';
import { ConfigurationSettingsComponent } from './components/configuration-settings/configuration-settings.component';
import { SettingsRowSlideComponent } from './components/settings-row/settings-row-slide.component';

import { TagEditorComponent } from './components/tag-editor/tag-editor.component';

@NgModule({
  declarations: [
    ConfigurationOverviewComponent,
    AnalyticTypeInfoDialogComponent,
    ConfigurationSettingsComponent,
    SettingsRowSlideComponent,
    CallbackUrlDialogComponent,
    TagEditorComponent,
    ConfigurationAnalyticItemsSummaryComponent,
  ],
  imports: [AppSharedModule, NgbPopoverModule],
  exports: [
    ConfigurationSettingsComponent,
    ConfigurationOverviewComponent,
    AnalyticTypeInfoDialogComponent,
    TagEditorComponent,
    ConfigurationAnalyticItemsSummaryComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfigurationSharedModule {}
